// extracted by css-extract-rspack-plugin
export default {"infoTrigger":"infoTrigger-Uc6JOS"};